import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/918700059442?text=Hi%20Finzpe%2C%20I%20need%20help%20with%20a%20loan"
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full flex items-center justify-center text-white shadow-lg hover:scale-105 transition-transform"
      style={{ background: "linear-gradient(135deg,#25D366,#128C7E)" }}
      aria-label="WhatsApp chat"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
